import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ActivityProvider } from "@/context/ActivityContext";
import Navbar from "@/components/Navbar";
import Home from "@/pages/Home";
import Championships from "@/pages/Championships";
import ChampionshipDetail from "@/pages/ChampionshipDetail";
import EventDetail from "@/pages/EventDetail";
import PilotDetail from "@/pages/PilotDetail";
import PilotsList from "@/pages/PilotsList";
import GlobalPilotDetail from "@/pages/GlobalPilotDetail";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import Gallery from "@/pages/Gallery";
import AuthPage from "@/pages/AuthPage";
import Organizer from "@/pages/Organizer";
import Contacts from "@/pages/Contacts";
import Notifiche from "@/pages/Notifiche";
import Locandine from "@/pages/Locandine";
import AnnouncementPopup from "@/components/AnnouncementPopup";
import AnalyticsTracker from "@/components/AnalyticsTracker";
import InstallPrompt from "@/components/InstallPrompt";

function AnimatedRoutes() {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={location.pathname}
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -10 }}
        transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
      >
        <Routes location={location}>
          <Route path="/" element={<Home />} />
          <Route path="/campionati" element={<Championships />} />
          <Route path="/campionati/:id" element={<ChampionshipDetail />} />
          <Route path="/campionati/:champId/pilota/:name" element={<PilotDetail />} />
          <Route path="/galleria" element={<Gallery />} />
          <Route path="/piloti" element={<PilotsList />} />
          <Route path="/piloti/:name" element={<GlobalPilotDetail />} />
          <Route path="/eventi/:id" element={<EventDetail />} />
          <Route path="/accedi" element={<AuthPage />} />
          <Route path="/organizza" element={<Organizer />} />
          <Route path="/campionati-tuoi" element={<Organizer />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/contatti" element={<Contacts />} />
          <Route path="/notifiche" element={<Notifiche />} />
          <Route path="/locandine" element={<Locandine />} />
        </Routes>
      </motion.div>
    </AnimatePresence>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-background">
      <BrowserRouter>
        <AuthProvider>
          <ActivityProvider>
            <Toaster theme="dark" position="top-right" richColors />
            <Navbar />
            <AnnouncementPopup />
            <InstallPrompt />
            <AnalyticsTracker />
            <AnimatedRoutes />
          </ActivityProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
